import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const buildFilterParams = (filters) => {
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 10,
  };

  if (filters.status) {
    params["filter.status"] = filters.status;
  }

  if (filters.search) {
    params.search = filters.search;
  }

  return params;
};

// ************ Gift Card Buy Orders (pending purchases) ************
const fetchPendingGiftCardPurchases = async (filters = {}) => {
  const response = await api.get("/v1/admin/personal/pending-gift-card-purchases", {
    params: buildFilterParams(filters),
    paramsSerializer: { indexes: null },
  });
  return response.data;
};

export const usePendingGiftCardPurchases = (filters = {}) => {
  return useQuery({
    queryKey: ["gift-card-buy-orders", filters],
    queryFn: () => fetchPendingGiftCardPurchases(filters),
    refetchOnWindowFocus: false,
  });
};

const retryGiftCardPurchase = async (uuid) => {
  const { data } = await api.post(`/v1/admin/personal/retry-gift-card-purchase/${uuid}`);
  return data;
};

export const useRetryGiftCardPurchase = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retryGiftCardPurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gift-card-buy-orders"] });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ["gift-card-buy-orders"] });
    },
  });
};

// ************ Gift Card Sell Orders ************
const fetchGiftCardSellOrders = async (filters = {}) => {
  const response = await api.get("/v1/admin/personal/gift-card-sell-orders", {
    params: buildFilterParams(filters),
    paramsSerializer: { indexes: null },
  });
  return response.data;
};

export const useGiftCardSellOrders = (filters = {}) => {
  return useQuery({
    queryKey: ["gift-card-sell-orders", filters],
    queryFn: () => fetchGiftCardSellOrders(filters),
    refetchOnWindowFocus: false,
  });
};
